import { ChangeDetectionStrategy, Component, effect, inject, signal } from "@angular/core";
import { NavigationEnd, Router, RouterLinkActive } from "@angular/router";
import { BaseComponent } from "primeng/basecomponent";
import { filter } from "rxjs";
import { SidenavPanelStyle } from "./sidenav-panel.style";

@Component({
  selector: "ui-sidenav-panel",
  templateUrl: "./sidenav-panel.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [RouterLinkActive],
  host: {
    "[class]": "cx('root')",
    "(click)": "onClick($event)",
    "(window:click)": "onWindowClick($event)",
  },
})
export class SidenavPanelComponent extends BaseComponent {
  protected readonly _componentStyle = inject(SidenavPanelStyle);

  private readonly routerLinkActive = inject(RouterLinkActive);
  protected readonly _routerLinkActiveClass = effect(() => {
    this.routerLinkActive.routerLinkActive = this.cx("active");
  });

  readonly active = signal<boolean>(false);

  private readonly router = inject(Router);
  private readonly hasJustNavigated = signal<boolean>(false);
  protected readonly navigation = this.router.events.pipe(filter((x) => x instanceof NavigationEnd)).subscribe(() => {
    // seemingly better than `debounceTime(50)`
    this.hasJustNavigated.set(true);
    setTimeout(() => this.hasJustNavigated.set(false), 50);
    this.active.set(false);
  });

  protected onClick(_event: MouseEvent): void {
    if (!this.hasJustNavigated()) {
      this.active.update((x) => !x);
    }
  }

  protected onWindowClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!this.rootEl.contains(target) && !target.closest(".p-overlay-mask")) {
      this.active.set(false);
    }
  }
}
